// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import userNode css modules
import userNodeStyles from '../userNodeModuleStyles.css';

function UserNodeListItem({ userNode }) {
  return (
    <li>
      <Link to={`/user-nodes/${userNode._id}`}> {userNode.name}</Link>
    </li>
  )
}

UserNodeListItem.propTypes = {
  userNode: PropTypes.object.isRequired
}

export default UserNodeListItem;



// WEBPACK FOOTER //
// modules/userNode/components/UserNodeListItem.js.jsx